import { TRACKING_KEY, TRACKING_EVENT } from 'shared/constants';

// eslint-disable-next-line import/prefer-default-export
export const trackCOBLinkClicked = (tracking) => {
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.COB_LINK_CLICKED,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};
